/* eslint-disable */
import React from 'react';

export type MisconceptionCardIconRender = (active: boolean) => React.ReactNode;

export const MISCONCEPTION_CARD_ICONS: MisconceptionCardIconRender[] = [
  // 感叹号
  (active: boolean) => (
    <svg
      width="73"
      height="73"
      viewBox="0 0 73 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.209 51.7083H12.1673C10.5539 51.7083 9.0066 51.0674 7.86575 49.9266C6.7249 48.7857 6.08398 47.2384 6.08398 45.625V15.2083C6.08398 13.5949 6.7249 12.0476 7.86575 10.9068C9.0066 9.76592 10.5539 9.125 12.1673 9.125H60.834C62.4474 9.125 63.9947 9.76592 65.1355 10.9068C66.2764 12.0476 66.9173 13.5949 66.9173 15.2083V45.625C66.9173 47.2384 66.2764 48.7857 65.1355 49.9266C63.9947 51.0674 62.4474 51.7083 60.834 51.7083H57.7923M36.5006 45.625L51.709 63.875H21.2923L36.5006 45.625Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 指南针
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 24V36M36 48H36.03M23.58 6H48.42L66 23.58V48.42L48.42 66H23.58L6 48.42V23.58L23.58 6Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 向上箭头
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M60 27L39 6H18C16.4087 6 14.8826 6.63214 13.7574 7.75736C12.6321 8.88258 12 10.4087 12 12V60C12 61.5913 12.6321 63.1174 13.7574 64.2426C14.8826 65.3679 16.4087 66 18 66H54C55.5913 66 57.1174 65.3679 58.2426 64.2426C59.3679 63.1174 60 61.5913 60 60V27ZM39 6V27H60"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 锚
  (active: boolean) => (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 45H12C10.4087 45 8.88258 44.3679 7.75736 43.2426C6.63214 42.1174 6 40.5913 6 39V12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6H39C40.5913 6 42.1174 6.63214 43.2426 7.75736C44.3679 8.88258 45 10.4087 45 12V15M33 27H60C63.3137 27 66 29.6863 66 33V60C66 63.3137 63.3137 66 60 66H33C29.6863 66 27 63.3137 27 60V33C27 29.6863 29.6863 27 33 27Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

export const tpv_ICON_Map: MisconceptionCardIconRender[] = [
  (active: boolean) => (
    <svg
      width="69"
      height="69"
      viewBox="0 0 69 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.5 63.25C50.3782 63.25 63.25 50.3782 63.25 34.5C63.25 18.6218 50.3782 5.75 34.5 5.75C18.6218 5.75 5.75 18.6218 5.75 34.5C5.75 50.3782 18.6218 63.25 34.5 63.25Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.5 43.125C39.2635 43.125 43.125 39.2635 43.125 34.5C43.125 29.7365 39.2635 25.875 34.5 25.875C29.7365 25.875 25.875 29.7365 25.875 34.5C25.875 39.2635 29.7365 43.125 34.5 43.125Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="63"
      height="63"
      viewBox="0 0 63 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0913 2.625L15.75 42C15.75 43.3924 16.3031 44.7277 17.2877 45.7123C18.2723 46.6969 19.6076 47.25 21 47.25H60.375M2.625 16.0913L42 15.75C43.3924 15.75 44.7277 16.3031 45.7123 17.2877C46.6969 18.2723 47.25 19.6076 47.25 21V60.375"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M62.3332 34.0013C62.3332 49.6494 49.6479 62.3346 33.9998 62.3346M62.3332 34.0013C62.3332 18.3532 49.6479 5.66797 33.9998 5.66797M62.3332 34.0013H50.9998M33.9998 62.3346C18.3518 62.3346 5.6665 49.6494 5.6665 34.0013M33.9998 62.3346V51.0013M5.6665 34.0013C5.6665 18.3532 18.3518 5.66797 33.9998 5.66797M5.6665 34.0013H16.9998M33.9998 5.66797V17.0013"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 46.75L33 60.5L60.5 46.75M5.5 33L33 46.75L60.5 33M33 5.5L5.5 19.25L33 33L60.5 19.25L33 5.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

export const TPV_PRACTICE_GRID_ICONS: MisconceptionCardIconRender[] = [
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42 42L33.3 33.3M38 22C38 30.8366 30.8366 38 22 38C13.1634 38 6 30.8366 6 22C6 13.1634 13.1634 6 22 6C30.8366 6 38 13.1634 38 22Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34 42V26H14V42M14 6V16H30M38 42H10C8.93913 42 7.92172 41.5786 7.17157 40.8284C6.42143 40.0783 6 39.0609 6 38V10C6 8.93913 6.42143 7.92172 7.17157 7.17157C7.92172 6.42143 8.93913 6 10 6H32L42 16V38C42 39.0609 41.5786 40.0783 40.8284 40.8284C40.0783 41.5786 39.0609 42 38 42Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1137_954)">
        <path
          d="M24 30C27.3137 30 30 27.3137 30 24C30 20.6863 27.3137 18 24 18C20.6863 18 18 20.6863 18 24C18 27.3137 20.6863 30 24 30Z"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.8 30C38.5338 30.6032 38.4544 31.2724 38.572 31.9212C38.6896 32.57 38.9989 33.1686 39.46 33.64L39.58 33.76C39.9519 34.1315 40.2469 34.5726 40.4482 35.0582C40.6495 35.5438 40.7531 36.0643 40.7531 36.59C40.7531 37.1157 40.6495 37.6362 40.4482 38.1218C40.2469 38.6074 39.9519 39.0485 39.58 39.42C39.2085 39.7919 38.7674 40.0869 38.2818 40.2882C37.7962 40.4895 37.2757 40.5931 36.75 40.5931C36.2243 40.5931 35.7038 40.4895 35.2182 40.2882C34.7326 40.0869 34.2915 39.7919 33.92 39.42L33.8 39.3C33.3286 38.8389 32.73 38.5296 32.0812 38.412C31.4324 38.2944 30.7632 38.3738 30.16 38.64C29.5685 38.8935 29.064 39.3145 28.7086 39.8511C28.3533 40.3877 28.1626 41.0164 28.16 41.66V42C28.16 43.0609 27.7386 44.0783 26.9884 44.8284C26.2383 45.5786 25.2209 46 24.16 46C23.0991 46 22.0817 45.5786 21.3316 44.8284C20.5814 44.0783 20.16 43.0609 20.16 42V41.82C20.1445 41.158 19.9302 40.516 19.545 39.9774C19.1598 39.4388 18.6215 39.0286 18 38.8C17.3968 38.5338 16.7276 38.4544 16.0788 38.572C15.43 38.6896 14.8314 38.9989 14.36 39.46L14.24 39.58C13.8685 39.9519 13.4274 40.2469 12.9418 40.4482C12.4562 40.6495 11.9357 40.7531 11.41 40.7531C10.8843 40.7531 10.3638 40.6495 9.87824 40.4482C9.39265 40.2469 8.95149 39.9519 8.58 39.58C8.20809 39.2085 7.91306 38.7674 7.71176 38.2818C7.51046 37.7962 7.40685 37.2757 7.40685 36.75C7.40685 36.2243 7.51046 35.7038 7.71176 35.2182C7.91306 34.7326 8.20809 34.2915 8.58 33.92L8.7 33.8C9.16107 33.3286 9.47037 32.73 9.58801 32.0812C9.70565 31.4324 9.62623 30.7632 9.36 30.16C9.10647 29.5685 8.68551 29.064 8.14893 28.7086C7.61235 28.3533 6.98357 28.1626 6.34 28.16H6C4.93913 28.16 3.92172 27.7386 3.17157 26.9884C2.42143 26.2383 2 25.2209 2 24.16C2 23.0991 2.42143 22.0817 3.17157 21.3316C3.92172 20.5814 4.93913 20.16 6 20.16H6.18C6.84199 20.1445 7.48401 19.9302 8.0226 19.545C8.56119 19.1598 8.97143 18.6215 9.2 18C9.46623 17.3968 9.54565 16.7276 9.42801 16.0788C9.31037 15.43 9.00107 14.8314 8.54 14.36L8.42 14.24C8.04809 13.8685 7.75306 13.4274 7.55176 12.9418C7.35046 12.4562 7.24685 11.9357 7.24685 11.41C7.24685 10.8843 7.35046 10.3638 7.55176 9.87824C7.75306 9.39265 8.04809 8.95149 8.42 8.58C8.79149 8.20809 9.23265 7.91306 9.71824 7.71176C10.2038 7.51046 10.7243 7.40685 11.25 7.40685C11.7757 7.40685 12.2962 7.51046 12.7818 7.71176C13.2674 7.91306 13.7085 8.20809 14.08 8.58L14.2 8.7C14.6714 9.16107 15.27 9.47037 15.9188 9.58801C16.5676 9.70565 17.2368 9.62623 17.84 9.36H18C18.5915 9.10647 19.096 8.68551 19.4514 8.14893C19.8067 7.61235 19.9974 6.98357 20 6.34V6C20 4.93913 20.4214 3.92172 21.1716 3.17157C21.9217 2.42143 22.9391 2 24 2C25.0609 2 26.0783 2.42143 26.8284 3.17157C27.5786 3.92172 28 4.93913 28 6V6.18C28.0026 6.82357 28.1933 7.45235 28.5486 7.98893C28.904 8.52551 29.4085 8.94647 30 9.2C30.6032 9.46623 31.2724 9.54565 31.9212 9.42801C32.57 9.31037 33.1686 9.00107 33.64 8.54L33.76 8.42C34.1315 8.04809 34.5726 7.75306 35.0582 7.55176C35.5438 7.35046 36.0643 7.24685 36.59 7.24685C37.1157 7.24685 37.6362 7.35046 38.1218 7.55176C38.6074 7.75306 39.0485 8.04809 39.42 8.42C39.7919 8.79149 40.0869 9.23265 40.2882 9.71824C40.4895 10.2038 40.5931 10.7243 40.5931 11.25C40.5931 11.7757 40.4895 12.2962 40.2882 12.7818C40.0869 13.2674 39.7919 13.7085 39.42 14.08L39.3 14.2C38.8389 14.6714 38.5296 15.27 38.412 15.9188C38.2944 16.5676 38.3738 17.2368 38.64 17.84V18C38.8935 18.5915 39.3145 19.096 39.8511 19.4514C40.3877 19.8067 41.0164 19.9974 41.66 20H42C43.0609 20 44.0783 20.4214 44.8284 21.1716C45.5786 21.9217 46 22.9391 46 24C46 25.0609 45.5786 26.0783 44.8284 26.8284C44.0783 27.5786 43.0609 28 42 28H41.82C41.1764 28.0026 40.5477 28.1933 40.0111 28.5486C39.4745 28.904 39.0535 29.4085 38.8 30Z"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1137_954">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12H12.02M12 36H12.02M8 4H40C42.2091 4 44 5.79086 44 8V16C44 18.2091 42.2091 20 40 20H8C5.79086 20 4 18.2091 4 16V8C4 5.79086 5.79086 4 8 4ZM8 28H40C42.2091 28 44 29.7909 44 32V40C44 42.2091 42.2091 44 40 44H8C5.79086 44 4 42.2091 4 40V32C4 29.7909 5.79086 28 8 28Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 38C36 39.5913 35.3679 41.1174 34.2426 42.2426C33.1174 43.3679 31.5913 44 30 44C28.4087 44 26.8826 43.3679 25.7574 42.2426C24.6321 41.1174 24 39.5913 24 38V24M46 24C45.4776 18.5271 42.9341 13.4455 38.8661 9.74732C34.7981 6.04915 29.4977 4 24 4C18.5023 4 13.2019 6.04915 9.13393 9.74732C5.06594 13.4455 2.52241 18.5271 2 24H46Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

export const MISCONCEPTION_CARD_ICONS1: MisconceptionCardIconRender[] = [
  // 感叹号
  (active: boolean) => (
    <svg
      width="63"
      height="63"
      viewBox="0 0 63 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.5 19.5V31.5M31.5 43.5H31.53M61.5 31.5C61.5 48.0685 48.0685 61.5 31.5 61.5C14.9315 61.5 1.5 48.0685 1.5 31.5C1.5 14.9315 14.9315 1.5 31.5 1.5C48.0685 1.5 61.5 14.9315 61.5 31.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 指南针
  (active: boolean) => (
    <svg
      width="63"
      height="63"
      viewBox="0 0 63 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.5 61.5C48.0685 61.5 61.5 48.0685 61.5 31.5C61.5 14.9315 48.0685 1.5 31.5 1.5C14.9315 1.5 1.5 14.9315 1.5 31.5C1.5 48.0685 14.9315 61.5 31.5 61.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.22 18.78L37.86 37.86L18.78 44.22L25.14 25.14L44.22 18.78Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 向上箭头
  (active: boolean) => (
    <svg
      width="63"
      height="63"
      viewBox="0 0 63 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 31.5L31.5 19.5L43.5 31.5M31.5 19.5L31.5 43.5M1.5 31.5C1.5 14.9315 14.9315 1.5 31.5 1.5C48.0685 1.5 61.5 14.9315 61.5 31.5C61.5 48.0685 48.0685 61.5 31.5 61.5C14.9315 61.5 1.5 48.0685 1.5 31.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  // 锚
  (active: boolean) => (
    <svg
      width="63"
      height="63"
      viewBox="0 0 63 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.5 19.5C36.4706 19.5 40.5 15.4706 40.5 10.5C40.5 5.52944 36.4706 1.5 31.5 1.5C26.5294 1.5 22.5 5.52944 22.5 10.5C22.5 15.4706 26.5294 19.5 31.5 19.5ZM31.5 19.5V61.5M31.5 61.5C23.5435 61.5 15.9129 58.3393 10.2868 52.7132C4.66071 47.0871 1.5 39.4565 1.5 31.5H10.5M31.5 61.5C39.4565 61.5 47.0871 58.3393 52.7132 52.7132C58.3393 47.0871 61.5 39.4565 61.5 31.5H52.5"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];

export const SSO_CARD_ICONS: MisconceptionCardIconRender[] = [
  (active: boolean) => (
    <svg
      width="73"
      height="73"
      viewBox="0 0 73 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.4583 33.4585V21.2918M48.6667 33.4585V21.2918M63.875 6.0835H9.125V54.7502H24.3333V66.9168L36.5 54.7502H51.7083L63.875 42.5835V6.0835Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="68"
      height="56"
      viewBox="0 0 68 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48.1667 54V48.1667C48.1667 45.0725 46.9375 42.105 44.7496 39.9171C42.5617 37.7292 39.5942 36.5 36.5 36.5H13.1667C10.0725 36.5 7.10501 37.7292 4.91709 39.9171C2.72916 42.105 1.5 45.0725 1.5 48.1667V54M65.6667 54V48.1667C65.6647 45.5817 64.8044 43.0706 63.2206 41.0276C61.6369 38.9846 59.4195 37.5254 56.9167 36.8792M45.25 1.87917C47.7595 2.52171 49.9839 3.98121 51.5723 6.02757C53.1607 8.07393 54.0229 10.5908 54.0229 13.1813C54.0229 15.7717 53.1607 18.2886 51.5723 20.3349C49.9839 22.3813 47.7595 23.8408 45.25 24.4833M36.5 13.1667C36.5 19.61 31.2767 24.8333 24.8333 24.8333C18.39 24.8333 13.1667 19.61 13.1667 13.1667C13.1667 6.72334 18.39 1.5 24.8333 1.5C31.2767 1.5 36.5 6.72334 36.5 13.1667Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="51"
      height="63"
      viewBox="0 0 51 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 54C1.5 52.0109 2.29018 50.1032 3.6967 48.6967C5.10322 47.2902 7.01088 46.5 9 46.5H49.5M1.5 54C1.5 55.9891 2.29018 57.8968 3.6967 59.3033C5.10322 60.7098 7.01088 61.5 9 61.5H49.5V1.5H9C7.01088 1.5 5.10322 2.29018 3.6967 3.6967C2.29018 5.10322 1.5 7.01088 1.5 9V54Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="60"
      height="49"
      viewBox="0 0 60 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M58.1667 7.16667C58.1667 4.05 55.6167 1.5 52.5 1.5H7.16667C4.05 1.5 1.5 4.05 1.5 7.16667M58.1667 7.16667V41.1667C58.1667 44.2833 55.6167 46.8333 52.5 46.8333H7.16667C4.05 46.8333 1.5 44.2833 1.5 41.1667V7.16667M58.1667 7.16667L29.8333 27L1.5 7.16667"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];
export const PSA_CARD_ICONS: MisconceptionCardIconRender[] = [
  (active: boolean) => (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.8975 37.25C53.4505 35.4685 53.7377 33.6153 53.75 31.75V12.5L31.75 4.25L23.06 7.495M11.7575 11.7575L9.75 12.5V31.75C9.75 48.25 31.75 59.25 31.75 59.25C37.5718 56.1781 42.8042 52.1002 47.205 47.205M1.5 1.5L62 62"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.625 19.5C27.7575 19.5 26.25 17.9925 26.25 16.125V4.875C26.25 3.0075 27.7575 1.5 29.625 1.5C31.4925 1.5 33 3.0075 33 4.875V16.125C33 17.9925 31.4925 19.5 29.625 19.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.125 19.5H39.75V16.125C39.75 14.2575 41.2575 12.75 43.125 12.75C44.9925 12.75 46.5 14.2575 46.5 16.125C46.5 17.9925 44.9925 19.5 43.125 19.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.375 28.5C20.2425 28.5 21.75 30.0075 21.75 31.875V43.125C21.75 44.9925 20.2425 46.5 18.375 46.5C16.5075 46.5 15 44.9925 15 43.125V31.875C15 30.0075 16.5075 28.5 18.375 28.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.875 28.5H8.25V31.875C8.25 33.7425 6.7425 35.25 4.875 35.25C3.0075 35.25 1.5 33.7425 1.5 31.875C1.5 30.0075 3.0075 28.5 4.875 28.5Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.5 29.625C28.5 27.7575 30.0075 26.25 31.875 26.25H43.125C44.9925 26.25 46.5 27.7575 46.5 29.625C46.5 31.4925 44.9925 33 43.125 33H31.875C30.0075 33 28.5 31.4925 28.5 29.625Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.875 39.75H28.5V43.125C28.5 44.9925 30.0075 46.5 31.875 46.5C33.7425 46.5 35.25 44.9925 35.25 43.125C35.25 41.2575 33.7425 39.75 31.875 39.75Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 18.375C19.5 16.5075 17.9925 15 16.125 15H4.875C3.0075 15 1.5 16.5075 1.5 18.375C1.5 20.2425 3.0075 21.75 4.875 21.75H16.125C17.9925 21.75 19.5 20.2425 19.5 18.375Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.125 8.25H19.5V4.875C19.5 3.0075 17.9925 1.5 16.125 1.5C14.2575 1.5 12.75 3.0075 12.75 4.875C12.75 6.7425 14.2575 8.25 16.125 8.25Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="46"
      height="48"
      viewBox="0 0 46 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44 14V1.5H31.5M44 1.5L1.5 44M31.5 46.5H44V34M44 46.5L29 31.5M1.5 4L14 16.5"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="53"
      height="53"
      viewBox="0 0 53 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.0833 50.6667C39.6603 50.6667 50.6667 39.6603 50.6667 26.0833C50.6667 12.5063 39.6603 1.5 26.0833 1.5C12.5063 1.5 1.5 12.5063 1.5 26.0833C1.5 39.6603 12.5063 50.6667 26.0833 50.6667Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.0833 40.8333C34.2295 40.8333 40.8333 34.2295 40.8333 26.0833C40.8333 17.9371 34.2295 11.3333 26.0833 11.3333C17.9371 11.3333 11.3333 17.9371 11.3333 26.0833C11.3333 34.2295 17.9371 40.8333 26.0833 40.8333Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.0833 31C28.7987 31 31 28.7987 31 26.0833C31 23.3679 28.7987 21.1667 26.0833 21.1667C23.3679 21.1667 21.1667 23.3679 21.1667 26.0833C21.1667 28.7987 23.3679 31 26.0833 31Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];
export const PSA_RISKS_ICONS: MisconceptionCardIconRender[] = [
  (active: boolean) => (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.115 40.115C36.2688 43.0468 31.5855 44.6709 26.75 44.75C11 44.75 2 26.75 2 26.75C4.79875 21.5343 8.68055 16.9774 13.385 13.385M22.025 9.29C23.5737 8.92748 25.1594 8.74626 26.75 8.75C42.5 8.75 51.5 26.75 51.5 26.75C50.1342 29.3051 48.5054 31.7107 46.64 33.9275M31.52 31.52C30.902 32.1832 30.1568 32.7151 29.3288 33.084C28.5008 33.453 27.607 33.6513 26.7007 33.6673C25.7944 33.6833 24.8941 33.5166 24.0536 33.1771C23.2131 32.8376 22.4496 32.3323 21.8087 31.6913C21.1677 31.0504 20.6624 30.2869 20.3229 29.4464C19.9834 28.6059 19.8167 27.7056 19.8327 26.7993C19.8487 25.893 20.047 24.9992 20.416 24.1712C20.7849 23.3432 21.3168 22.598 21.98 21.98M2 2L51.5 51.5"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="49"
      height="50"
      viewBox="0 0 49 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.5 15.5188L2 47.0188M36.875 31.2688H17.75M43.04 25.0588C45.5731 22.5256 46.9963 19.0899 46.9963 15.5075C46.9963 11.9251 45.5731 8.48941 43.04 5.95626C40.5069 3.42311 37.0712 2 33.4887 2C29.9063 2 26.4706 3.42311 23.9375 5.95626L8.75 21.1438V40.2688H27.875L43.04 25.0588Z"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 2V29M8.75 29C5.02208 29 2 32.0221 2 35.75C2 39.4779 5.02208 42.5 8.75 42.5C12.4779 42.5 15.5 39.4779 15.5 35.75M8.75 29C12.4779 29 15.5 32.0221 15.5 35.75M35.75 15.5C39.4779 15.5 42.5 12.4779 42.5 8.75C42.5 5.02208 39.4779 2 35.75 2C32.0221 2 29 5.02208 29 8.75C29 12.4779 32.0221 15.5 35.75 15.5ZM35.75 15.5C35.75 20.8706 33.6165 26.0213 29.8189 29.8189C26.0213 33.6165 20.8706 35.75 15.5 35.75"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="49"
      height="49"
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 24.5H33.5M47 24.5C47 36.9264 36.9264 47 24.5 47C12.0736 47 2 36.9264 2 24.5C2 12.0736 12.0736 2 24.5 2C36.9264 2 47 12.0736 47 24.5Z"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  (active: boolean) => (
    <svg
      width="49"
      height="49"
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M47 2L22.25 26.75M22.25 26.75L2 17.75L47 2L31.25 47L22.25 26.75Z"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
];
